import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34ff574e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Current account information:", -1))
const _hoisted_4 = { class: "address-section" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Insured mailing address:")
], -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Execute Cancellation:", -1))
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Pending Cancellation:", -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = {
  key: 2,
  class: "processing-text"
}
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Could not find any active or scheduled policies ")
const _hoisted_20 = { class: "button-group" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Policy/policies:")
], -1))
const _hoisted_24 = { key: 1 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Policy/policies:")
], -1))
const _hoisted_26 = ["value", "id"]
const _hoisted_27 = ["for", "innerHTML"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Cancellation reason:")
], -1))
const _hoisted_30 = ["value"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Effective date:")
], -1))
const _hoisted_32 = ["disabled"]
const _hoisted_33 = {
  key: 2,
  class: "error"
}
const _hoisted_34 = {
  key: 3,
  class: "error"
}
const _hoisted_35 = {
  key: 4,
  class: "error"
}
const _hoisted_36 = {
  key: 5,
  class: "error",
  id: "js-scheduled-renewal-warning"
}
const _hoisted_37 = {
  key: 6,
  class: "error",
  id: "js-quoted-renewal-warning"
}
const _hoisted_38 = { key: 7 }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "cancel-policy-confirm" }, "I confirm", -1))
const _hoisted_40 = { class: "button-group" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = { key: 2 }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Cancellation Summary", -1))
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Reason", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Method", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Eff. Date", -1))
const _hoisted_49 = {
  key: 0,
  class: "processing-text"
}
const _hoisted_50 = {
  key: 1,
  class: "error"
}
const _hoisted_51 = { class: "button-group" }
const _hoisted_52 = ["disabled"]
const _hoisted_53 = { key: 3 }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Cancellation Complete!", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Reason", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Method", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Eff. Date", -1))
const _hoisted_58 = { key: 0 }
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" Waiting for cancellation doc...")
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "processing-text" }, "loading...", -1))
const _hoisted_61 = [
  _hoisted_59,
  _hoisted_60
]
const _hoisted_62 = { key: 1 }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { key: 1 }
const _hoisted_65 = { class: "button-group" }
const _hoisted_66 = { key: 4 }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Rescind complete", -1))
const _hoisted_68 = { key: 0 }
const _hoisted_69 = {
  key: 1,
  class: "error"
}
const _hoisted_70 = { class: "button-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.accountInfo !== null && _ctx.userOktaInfo !== null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.state === 'REVIEW')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", null, _toDisplayString(_ctx.address.AddressLine1), 1),
                (!!_ctx.address.AddressLine2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.address.AddressLine2), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, _toDisplayString(_ctx.address.City + ', ' + _ctx.address.State + ' ' + _ctx.address.PostalCode), 1)
              ]),
              (_ctx.hasCancellationPermission && !_ctx.hasPendingCancel)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.beginCancellation())),
                      id: "js-start-cancellation"
                    }, "Start")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasCancellationPermission && _ctx.hasPendingCancel)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _hoisted_10,
                    (!_ctx.hasActiveXs)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, " This account has a cancellation pending. No further cancellations can be performed in the app while this cancellation is still pending. "))
                      : _createCommentVNode("", true),
                    _hoisted_12,
                    (_ctx.hasActiveXs)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, " This account has a cancellation pending. Since this account has XS, withdrawing cancellations is not permitted in this app. (Please use Guidewire to handle this case.) "))
                      : _createCommentVNode("", true),
                    _hoisted_14,
                    (_ctx.processingWithdraw)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, "Withdrawing..."))
                      : _createCommentVNode("", true),
                    (!_ctx.hasActiveXs)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 3,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.withdraw())),
                          disabled: _ctx.processingWithdraw,
                          id: "js-withdraw-cancellation"
                        }, " Withdraw cancellation ", 8, _hoisted_16))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.state === 'START')
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              (_ctx.policyOptions.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("button", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.restartCancellation()))
                      }, "< Back")
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.policyOptions.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    (_ctx.policyOptions.length === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _hoisted_23,
                          _createTextVNode(" " + _toDisplayString(_ctx.policyOptions[0].label), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.policyOptions.length > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _hoisted_25,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.policyOptions, (policy) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: policy.label
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                value: policy.policyNumber,
                                id: 'cancel-policy-select-' + policy.policyNumber,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedPolicy = $event))
                              }, null, 8, _hoisted_26), [
                                [_vModelRadio, _ctx.selectedPolicy]
                              ]),
                              _createElementVNode("label", {
                                for: 'cancel-policy-select-' + policy.policyNumber,
                                innerHTML: policy.label
                              }, null, 8, _hoisted_27),
                              _hoisted_28
                            ], 64))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_29,
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.cancelReason = $event)),
                      class: "reason-selector",
                      onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleReasonChange()))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cancelReasons, (reason) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: reason,
                          value: reason
                        }, _toDisplayString(_ctx.CANCEL_REASON_LABELS[reason]), 9, _hoisted_30))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, _ctx.cancelReason]
                    ]),
                    _hoisted_31,
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.effectiveDate = $event)),
                      disabled: _ctx.cancelReason === 'nottaken'
                    }, null, 8, _hoisted_32), [
                      [_vModelText, _ctx.effectiveDate]
                    ]),
                    (_ctx.cancellationIsDatedTooLate)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, " This effective date is later than the policy expiration. Please review the policy information and choose a more appropriate date. "))
                      : _createCommentVNode("", true),
                    (_ctx.cancellationIsDatedTooEarly)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, " This effective date is earlier than the policy's effective. Please review the policy information and choose a more appropriate date. "))
                      : _createCommentVNode("", true),
                    (_ctx.hasXsSelected)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, " Cancellation of XS policies is currently not supported. That feature will be coming soon! "))
                      : _createCommentVNode("", true),
                    (_ctx.displayScheduledRenewalWarning && !_ctx.confirmCancel)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, " You are attempting to initiate a cancellation for a policy that is expiring in less than 30 days and has a renewal term scheduled. To proceed with this transaction, please confirm below that the broker/insured has requested to cancel the active term, and not the renewal term. "))
                      : _createCommentVNode("", true),
                    (_ctx.displayQuotedRenewalWarning && !_ctx.confirmCancel)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, " You are attempting to initiate a cancellation for a policy that is expiring in less than 90 days and has a renewal term quoted. To proceed with this transaction, please confirm below that the broker/insured has requested to cancel the active term, and not to withdraw the renewal quote. "))
                      : _createCommentVNode("", true),
                    (_ctx.displayRenewalWarning)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            id: "cancel-policy-confirm",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.confirmCancel = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.confirmCancel]
                          ]),
                          _hoisted_39
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("button", {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.restartCancellation()))
                      }, "< Back"),
                      _createElementVNode("button", {
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.finalizeCancellation())),
                        id: "js-finalize-cancellation",
                        disabled: _ctx.cancellationIsDatedTooLate ||
                       _ctx.cancellationIsDatedTooEarly ||
                       _ctx.hasXsSelected ||
                       _ctx.hasNotConfirmedRenewalCancellation
                      }, " Next ", 8, _hoisted_41)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.state === 'FINALIZE')
          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
              _createElementVNode("div", null, [
                _hoisted_43,
                _createElementVNode("div", null, [
                  _createElementVNode("b", null, [
                    _createElementVNode("span", { innerHTML: _ctx.policyLabel }, null, 8, _hoisted_44)
                  ]),
                  _hoisted_45
                ]),
                _createElementVNode("div", null, [
                  _hoisted_46,
                  _createTextVNode(": " + _toDisplayString(_ctx.CANCEL_REASON_LABELS[_ctx.cancelReason]), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_47,
                  _createTextVNode(": " + _toDisplayString(_ctx.REFUND_METHOD_LABELS[_ctx.refundMethod]), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_48,
                  _createTextVNode(": " + _toDisplayString(_ctx.effectiveDate), 1)
                ])
              ]),
              (_ctx.submitting)
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, "Cancelling..."))
                : _createCommentVNode("", true),
              (_ctx.hasSubmitError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, "Error: cancellation failed."))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("button", {
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.beginCancellation(true)))
                }, "< Back"),
                _createElementVNode("button", {
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.submit())),
                  class: "submit-button",
                  disabled: _ctx.submitting,
                  id: "js-submit-cancellation",
                  title: "This will execute the cancellation immediately, equivalent to clicking 'Cancel Now' in Guidewire."
                }, " Cancel Now ", 8, _hoisted_52)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.state === 'SUBMITTED')
          ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
              _createElementVNode("div", null, [
                _hoisted_54,
                _createElementVNode("div", null, [
                  _hoisted_55,
                  _createTextVNode(": " + _toDisplayString(_ctx.CANCEL_REASON_LABELS[_ctx.cancelReason]), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_56,
                  _createTextVNode(": " + _toDisplayString(_ctx.REFUND_METHOD_LABELS[_ctx.refundMethod]), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_57,
                  _createTextVNode(": " + _toDisplayString(_ctx.effectiveDate), 1)
                ]),
                (!_ctx.hasDocumentAvailable)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, _hoisted_61))
                  : _createCommentVNode("", true),
                (_ctx.hasDocumentAvailable)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                      _createElementVNode("a", {
                        href: "",
                        onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.downloadCancellationDocument()), ["prevent"]))
                      }, " Download cancellation doc "),
                      (_ctx.isDownloading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_63, "Downloading..."))
                        : _createCommentVNode("", true),
                      (_ctx.hasDownloadError)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_64, "Error downloading!"))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("button", {
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.restartCancellation())),
                  class: "submit-button"
                }, "Back")
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.state === 'RESCINDED')
          ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
              _createElementVNode("div", null, [
                _hoisted_67,
                (!_ctx.hasRescindError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_68, "Successfully rescinded the pending cancellation"))
                  : _createCommentVNode("", true),
                (_ctx.hasRescindError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_69, "Error: there was a problem rescinding the cancellation"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("button", {
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.restartCancellation())),
                  class: "submit-button"
                }, "Back")
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}